import { Injectable, OnDestroy } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';

@UntilDestroy({ checkProperties: true})
@Injectable()
export class FuseNavigationService implements OnDestroy {
    flatNavigation: any[] = [];

    onItemCollapsed: Subject<any> = new Subject();
    onItemCollapseToggled: Subject<any> = new Subject();

    constructor() {
    }

    ngOnDestroy(): void {
        this.onItemCollapseToggled?.unsubscribe();
        this.onItemCollapseToggled?.unsubscribe();
    }
    /**
     * Get flattened navigation array
     * @param navigation
     * @returns {any[]}
     */
    getFlatNavigation(navigation) {
        for (const navItem of navigation) {
            if (navItem.type === 'item') {
                this.flatNavigation.push({
                    title: navItem.title,
                    type: navItem.type,
                    hidden: navItem.hidden,
                    icon: navItem.icon || false,
                    url: navItem.url,
                });

                continue;
            }

            if (navItem.type === 'collapse' || navItem.type === 'group') {
                if (navItem.children) {
                    this.getFlatNavigation(navItem.children);
                }
            }
        }

        return this.flatNavigation;
    }
}
